import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import Wordmark from "./Wordmark";
import { useLocations } from "./PublicHeader";

export default function PublicFooter() {
  const { data } = useLocations();
  const cities = data?.cities || [];
  const col = "space-y-2.5 text-sm";
  const a = "text-lux-text/75 hover:text-lux-silverBright transition-colors";
  return (
    <footer className="mt-24 border-t border-lux-border bg-lux-bg">
      <div className="mx-auto max-w-6xl px-4 pb-24 pt-14 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Wordmark size="text-3xl" testId="footer-wordmark" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-lux-muted">
              LUX is a neutral directory of verified independent advertisers in London, Birmingham and Manchester. We never arrange meetings, take bookings or handle payments. Contact happens off-platform.
            </p>
            <a href="tel:08000121700" className="mt-6 inline-flex items-center gap-2 rounded-[10px] border border-lux-border px-3.5 py-2.5 text-sm text-lux-text hover:border-lux-silver/60" data-testid="footer-modern-slavery-helpline">
              <Phone className="h-4 w-4 text-lux-silver" aria-hidden="true" />
              <span>Modern Slavery Helpline <span className="text-lux-silverBright">08000 121 700</span></span>
            </a>
          </div>
          <div>
            <p className="lux-label mb-4">Cities</p>
            <ul className={col}>
              {cities.map((c) => (
                <li key={c.slug}>
                  <Link to={`/${c.slug}`} className={a} data-testid={`footer-city-${c.slug}`}>{c.name}{c.is_default ? " (main)" : ""}</Link>
                  <span className="ml-2 text-xs text-lux-muted">{c.areas.length} areas</span>
                </li>
              ))}
              <li><Link to="/saved" className={a} data-testid="footer-saved-link">Saved profiles</Link></li>
            </ul>
          </div>
          <div>
            <p className="lux-label mb-4">Safety</p>
            <ul className={col}>
              <li><Link to="/safety" className={a} data-testid="footer-safety-link">Safety centre</Link></li>
              <li><Link to="/report" className={a} data-testid="footer-report-link">Report a concern</Link></li>
              <li><Link to="/help" className={a}>Help &amp; FAQ</Link></li>
              <li><Link to="/posting-guidelines" className={a} data-testid="footer-posting-guidelines-link">Posting guidelines</Link></li>
              <li><Link to="/advertiser/login" className={a}>Advertiser sign-in</Link></li>
            </ul>
          </div>
          <div>
            <p className="lux-label mb-4">Legal</p>
            <ul className={col}>
              <li><Link to="/terms" className={a} data-testid="footer-terms-link">Terms</Link></li>
              <li><Link to="/privacy" className={a} data-testid="footer-privacy-link">Privacy</Link></li>
              <li><Link to="/cookies" className={a} data-testid="footer-cookies-link">Cookies</Link></li>
              <li><Link to="/online-safety" className={a} data-testid="footer-online-safety-act-link">Online Safety Act statement</Link></li>
              <li><Link to="/complaints" className={a} data-testid="footer-complaints-policy-link">Complaints policy</Link></li>
            </ul>
          </div>
        </div>
        {cities.length > 0 && (
          <div className="mt-10 grid gap-6 border-t border-lux-border pt-8 sm:grid-cols-3" aria-label="Neighbourhoods by city">
            {cities.map((c) => (
              <div key={c.slug}>
                <p className="text-xs uppercase tracking-luxLabel text-lux-silver">{c.name}</p>
                <p className="mt-2 text-sm leading-7 text-lux-muted">
                  {c.areas.map((x, i) => (
                    <span key={x.slug}>{i > 0 && <span aria-hidden="true"> · </span>}<Link to={`/${c.slug}/${x.slug}`} className={a}>{x.name}</Link></span>
                  ))}
                </p>
              </div>
            ))}
          </div>
        )}
        <div className="mt-12 flex flex-col gap-3 border-t border-lux-border pt-6 text-xs text-lux-muted sm:flex-row sm:items-center sm:justify-between">
          <p>18+ only. Prototype for user testing - profiles marked <span className="lux-tag-demo mx-1">Demo</span> are fictional.</p>
          <p>No tracking or analytics scripts. Northern Ireland locations are not available.</p>
        </div>
      </div>
    </footer>
  );
}
